<template>
  <div class="container">
    <!-- 头部banner -->
  </div>
</template>

<script>
export default {
  name: "loading",
  data() {
    return {
      uid:"",
    };
  },
  created() {
    this.$toast.loading({
      forbidClick: true,
    });
    var that = this;
    var id = setInterval(function() {
      if (localStorage.getItem("uid") != null) {
        clearInterval(id);
        that.$toast.clear();
        that.$router.replace(localStorage.getItem("_url"));
      }
      this.uid=localStorage.getItem("uid");
    }, 100);
  },
  methods: {},
};
</script>
<style scoped>
.container {
  background-color: transparent !important;
  box-sizing: border-box;
  padding: 0;
  height: 100vh;
}
</style>
